import {EntityWithId} from "../baseEntities";

export enum AuthorizationRequestFields {
    Mail = 'mail',
    Password = 'password',
    ClientIp = 'ipClient',
    ModuleCod = 'codModulo'
}

export interface AuthorizationRequest {
    [AuthorizationRequestFields.Mail]: string;
    [AuthorizationRequestFields.Password]: string;
    [AuthorizationRequestFields.ClientIp]: string;
    [AuthorizationRequestFields.ModuleCod]: number;
}

export enum AuthorizationResponseFields {
    UserId = 'idUsuario',
    ProfileId = 'idPerfil',
    Lastname = 'apellidoNombre',
    GroupId = 'idGrupo',
    PersonRoleId = 'idRolPersona',
    PasswordChangeDaysRemaining = 'cantDiasParaCambiarPass',
    DefaultLanguage = 'idiomaDefault',
    IsBankGroup = 'esGrupoBanco',
    IsInternalGroup = 'esGrupoInterno',
    AuthToken = 'tokenAutorizacion',
    HasError = 'tieneError',
    ErrorDescription = 'descripcionError',
}

export interface AuthorizationResponse {
    [AuthorizationResponseFields.UserId]: number;
    [AuthorizationResponseFields.ProfileId]: number;
    [AuthorizationResponseFields.Lastname]: string;
    [AuthorizationResponseFields.GroupId]: number;
    [AuthorizationResponseFields.PersonRoleId]: number | null;
    [AuthorizationResponseFields.PasswordChangeDaysRemaining]: number;
    [AuthorizationResponseFields.DefaultLanguage]: string;
    [AuthorizationResponseFields.IsBankGroup]: boolean;
    [AuthorizationResponseFields.IsInternalGroup]: boolean;
    [AuthorizationResponseFields.AuthToken]: AuthToken;
    [AuthorizationResponseFields.HasError]: boolean;
    [AuthorizationResponseFields.ErrorDescription]: string;
}

export enum ChangePasswordRequestFields {
    UserId = 'idUsuario',
    ActualPassword = 'PasswordActual',
    NewPassword = 'PasswordNueva',
}

export interface ChangePasswordRequest {
    [ChangePasswordRequestFields.UserId]: number;
    [ChangePasswordRequestFields.ActualPassword]: string;
    [ChangePasswordRequestFields.NewPassword]: string;
}


export enum ActiveDirectoryAuthorizationRequestFields {
    Mail = 'Mail',
    FullName = 'NombreYApellido',
    GroupList = 'lstGrupos',
}

export interface ActiveDirectoryAuthorizationRequest {
    [ActiveDirectoryAuthorizationRequestFields.Mail]: string;
    [ActiveDirectoryAuthorizationRequestFields.FullName]: string;
    [ActiveDirectoryAuthorizationRequestFields.GroupList]: string[];
}

export enum SignupFields {
    Nombre = 'nombre',
    Apellido = 'apellido',
    DNI = 'dni',
    Genero = 'genero',
    Cargo = 'cargo',
    TipoCelular = 'tipoCelular',
    CodArea = 'codArea',
    Telefono = 'telefono',
    Email = 'email',
    Password = 'password'
}

export interface SignupSend {
    [SignupFields.Nombre]: string,
    [SignupFields.Apellido]: string,
    [SignupFields.DNI]: string,
    [SignupFields.Email]: string,
    [SignupFields.CodArea]: string,
    [SignupFields.Cargo]: string,
    [SignupFields.Genero]: string,
    [SignupFields.Telefono]: string,
    [SignupFields.TipoCelular]: string,
    [SignupFields.Password]: string
}

export enum UserFields {
    Nombre = 'nombre',
    Apellido = 'apellido',
    DNI = 'numeroDocumento',
    Genero = 'genero',
    Cargo = 'cargo',
    TipoCelular = 'tipoCelular',
    CodArea = 'codArea',
    Telefono = 'telefono',
    Email = 'mail'
}

export interface User extends EntityWithId<number> {
    [UserFields.Nombre]: string,
    [UserFields.Apellido]: string,
    [UserFields.DNI]: string,
    [UserFields.Email]: string,
    [UserFields.CodArea]: string,
    [UserFields.Cargo]: string,
    [UserFields.Genero]: string,
    [UserFields.Telefono]: string,
    [UserFields.TipoCelular]: string
}


export enum ChangePasswordDataFields {
    IdUsuario = 'IdUsuario',
    PasswordActual = 'PasswordActual',
    PasswordNueva = 'PasswordNueva'
}


export interface ChangePasswordData {
    [ChangePasswordDataFields.IdUsuario]: number
    [ChangePasswordDataFields.PasswordActual]: string,
    [ChangePasswordDataFields.PasswordNueva]: string
}


export enum AuthTokenFields {
    AuthToken = 'token',
    ExpirationTime = 'expiracionMinutos',
}

export interface AuthToken {
    [AuthTokenFields.AuthToken]: string;
    [AuthTokenFields.ExpirationTime]: number;
}
